import CreatableSelect from "react-select/creatable";
import "bootstrap/dist/css/bootstrap.min.css";
import {useTranslation} from "react-i18next";

const CreatableSearchSelect = ({
    options,
    placeholder = "Select an option",
    onChange,
    styles,
    value,
    defaultValue,
    isMulti = false,
    isClearable = false,
    name,
}) => {
    const defaultStyles = {
        control: (base) => ({
            ...base,
            height: "31.25px",
            minHeight: "31.25px",
            padding: "0px 0px 0px 6px",
            margin: "0px",
            display: "flex",
            alignItems: "center",
        }),
        valueContainer: (base) => ({
            ...base,
            height: "31.25px",
            display: "flex",
            alignItems: "center",
            padding: "0 6px",
        }),
        singleValue: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            lineHeight: "31.25px",
        }),
        placeholder: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            lineHeight: "31.25px",
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            height: "31.25px",
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "31.25px",
        }),
        option: (base, {isFocused, isSelected}) => ({
            ...base,
            backgroundColor: isSelected
                ? "#81d4fa"
                : isFocused
                ? "rgba(88,151,251,0.1)"
                : "transparent",
            color: isSelected ? "#ffffff" : base.color,
            "&:active": {
                backgroundColor: "#81d4fa",
            },
        }),
        menu: (base) => ({
            ...base,
            zIndex: 888,
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#e0e0e0",
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "#333",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "#333",
            ":hover": {
                backgroundColor: "#81d4fa",
                color: "white",
            },
        }),
    };
    const {t: _tf} = useTranslation("forms");

    const selectProps = {};
    if (name !== undefined) {
        selectProps.name = name;
    }
    if (value !== undefined) {
        selectProps.value = value;
    } else if (defaultValue !== undefined) {
        selectProps.defaultValue = defaultValue;
    }

    return (
        <CreatableSelect
            options={options}
            placeholder={placeholder}
            onChange={onChange}
            styles={styles || defaultStyles}
            noOptionsMessage={() => _tf("labels.nodata")}
            formatCreateLabel={(inputValue) => `Crear "${inputValue}"`}
            isMulti={isMulti}
            isClearable={isClearable}
            {...selectProps}
        />
    );
};

export default CreatableSearchSelect;
